"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationService = void 0;
var LocationService = /** @class */ (function () {
    function LocationService() {
    }
    Object.defineProperty(LocationService, "Instance", {
        get: function () {
            return this.instance || (this.instance = new this());
        },
        enumerable: false,
        configurable: true
    });
    LocationService.prototype.appendCurrentQueryStringsToUrl = function (url) {
        var _this = this;
        if (url === void 0) { url = ''; }
        var partialUrls = url.split('returnPath=');
        var isPartialUrl = partialUrls.length > 1;
        var updatedUrl = url;
        if (isPartialUrl) {
            updatedUrl = partialUrls.slice(-1).pop();
        }
        new URLSearchParams(location.search).forEach(function (value, key) {
            var allowQueryStringToBeIncludedInNextRedirect = key !== 'app-config' && key !== 'cidi' && key !== 'isMoving' && key !== 'bundle';
            if (allowQueryStringToBeIncludedInNextRedirect) {
                updatedUrl = _this.updateQueryStringParameter(updatedUrl, key, value);
            }
        });
        if (isPartialUrl) {
            updatedUrl = partialUrls[0] + 'returnPath=' + updatedUrl;
        }
        return updatedUrl.replace(/([^:]\/)\/+/g, '$1');
    };
    LocationService.prototype.updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp('([?&])' + key + '=.*?(&|#|$)', 'i');
        if (value === undefined) {
            if (uri.match(re)) {
                return uri.replace(re, '$1$2');
            }
            else {
                return uri;
            }
        }
        else {
            if (uri.match(re)) {
                return uri;
            }
            else {
                var hash = '';
                if (uri.indexOf('#') !== -1) {
                    hash = uri.replace(/.*#/, '#');
                    uri = uri.replace(/#.*/, '');
                }
                var separator = uri.indexOf('?') !== -1 ? '&' : '?';
                var encodedValue = encodeURI(decodeURI(value === undefined ? '' : value));
                return uri + separator + key + '=' + encodedValue + hash;
            }
        }
    };
    return LocationService;
}());
exports.locationService = new LocationService();
